<template>
	<div class="">
		<header-vue></header-vue>
		<div class="container-l2">
			<h1 class="h11">动环联动设置</h1>
			
			<br />
			<el-table
		    	stripe
				border
			    ref="multipleTable"
			    :data="deviceList"
			    tooltip-effect="dark"
			    style="width: 100%">
			    <el-table-column
			      type="index"
			      width="50">
			    </el-table-column>
			    <el-table-column
			      prop="mode_name"
			      label="名称"
			      show-overflow-tooltip>
			    </el-table-column>
			    <el-table-column
			      prop="mode_road"
			      label="模式方式"
			      show-overflow-tooltip>
			    </el-table-column>
			    <el-table-column
			      prop="mode_tag"
			      label="备注"
			      show-overflow-tooltip>
			    </el-table-column>
			   
			    <el-table-column
			      prop="mode_enable"
			      label="是否可用">
			    </el-table-column>
			    <el-table-column
		          label="操作">
		          <template slot-scope="scope">
		            
		            <el-button type="danger" size="small" v-if="scope.row.mode_enable=='Y'"
		                       @click="changeStatus(scope.row,'N')"> 禁止
		            </el-button>
					<el-button type="text" size="small" v-if="scope.row.mode_enable=='N'"
		                       @click="changeStatus(scope.row,'Y')"> 启动
		            </el-button>
		          </template>
		        </el-table-column>
			  </el-table>
			<br />
			<div class="text-right">
				<el-pagination
					@current-change="handleCurrentChange"
				  :page-size="pagesize"
				  layout="total, prev, pager, next"
				  :total="totalNum">
				</el-pagination>
			</div>
		</div>
		
	    
	    <loading v-if="showLoading"></loading>
	</div>  
</template>

<script>
	export default {
		mounted() {
			this.$nextTick(function(){
				
				this.getDeviceList();
		  	})
    	},
    	data(){
    		return{
    			deviceList:[],
    			nowPage:1,
    			totalNum:0,
    			pagesize:12,
    			formLabelWidth:'110px',
       			showLoading:false,
       			ifAdd:false,
       			manufac:{
       				name:"",
	       			contacts:"",
	       			email:"",
	       			tel:"",
	       			website:"",
	       			is_enabled:""
       			}
       			
    		}
    	},
    	methods:{
    		getDeviceList(){
    			this.showLoading = true;
				let valiCodeParams={
					uid:this.getCookie('uid'),
					page:this.nowPage,
					pagesize:this.pagesize,
			  		token:this.getCookie('token'),
			  		time:Date.parse( new Date()),
			  		terminalId:4
		  		};
		  		
		  		this.sign2(valiCodeParams);
		  		this.$ajax.post(this.$store.state.domain2+"/admin/Linkagemanage/list",this.$qs.stringify(valiCodeParams),{
		            emulateJSON: true
		        }).then(res=>{
		        	this.showLoading = false;
		        	if(res.data.code=="200"){
		        		this.deviceList = res.data.data.datalist;
		        		this.totalNum = res.data.data.totalNumber;
		        	}else if(res.data.code==10008){
		        		this.delCookie('username');
					      this.$router.push('/login/');
					      this.$store.commit('updateUserInfo', this.$store.state.originalUserInfo); 
		        	}else{
		        		//console.log(res.data.msg);
		        	}
		  		});
			},
			//			分页点击事件
			handleCurrentChange(val){
				this.nowPage = val;
				this.getDeviceList();
			},
		
		
			changeStatus(row,status){
				let valiCodeParams={
					uid:this.getCookie('uid'),
					id:row.id,
					mode_enable:status,
			  		token:this.getCookie('token'),
			  		time:Date.parse( new Date()),
			  		terminalId:4
		  		};
		  		
		  		this.sign2(valiCodeParams);
		  		this.$ajax.post(this.$store.state.domain2+"/admin/Linkagemanage/revise",this.$qs.stringify(valiCodeParams),{
		            emulateJSON: true
		        }).then(res=>{
		        	if(res.data.code=="200"){
		        		this.removeFlag = false;
		        		this.getDeviceList();
		        		this.$message.success(res.data.msg);
		        	}else if(res.data.code==10008){
		        		this.delCookie('username');
					      this.$router.push('/login/');
					      this.$store.commit('updateUserInfo', this.$store.state.originalUserInfo); 
		        	}else{
		        		this.$message.error(res.data.msg);
		        	}
		  		});
			},
			
			
    	}
   }
</script>

<style>
	.search-box2{margin-top: -69px;}
</style>


// WEBPACK FOOTER //
// src/components/alarm/envLinkage.vue